// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .new-security-page {
     font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
     background-color: #FFFFFF;
     color: #0A0A0A;
     overflow-x: hidden;
     padding-bottom: 50px;
 }

 .new-security-page * {
     box-sizing: border-box;
 }

 .security-container {
     max-width: 1480px;
     margin: 0 auto;
     padding: 0 20px;
 }

 /* --- Hero Section --- */
 .sec-hero {
     display: flex;
     align-items: center;
     justify-content: space-between;
     padding: 80px 0;
     position: relative;
 }

 .sec-hero-content {
     flex: 1 1 500px;
     padding-right: 40px;
 }

 .sec-hero-title {
     font-size: 60px;
     font-weight: 600;
     line-height: 1.1;
     margin-bottom: 15px;
     color: #101828;
 }

 .sec-hero-title span {
     color: #D3B06C;
 }

 .sec-hero-desc {
     font-size: 16px;
     color: #6A7282;
     line-height: 1.6;
     margin-bottom: 35px;
     max-width: 480px;
 }

 .sec-hero-actions {
     display: flex;
     gap: 15px;
     margin-bottom: 40px;
 }

 .sec-btn-primary {
     background-color: #D1AA67;
     color: #fff;

     text-decoration: none;
     display: inline-flex;
     align-items: center;
     justify-content: center;
     border: none;
     cursor: pointer;
     transition: all 0.3s;
 }

 .sec-btn-primary:hover {
     background-color: #C09D5B;
 }

 .sec-hero-actions a {
     padding: 10px 24px;
     font-size: 14px;
     border-radius: 30px;
     font-weight: 500;
 }

 .sec-rely-actions a {
     padding: 10px 24px;
     font-size: 14px;
     text-align: center;
     border-radius: 30px;
     font-weight: 500;
 }


 .sec-btn-outline {
     background-color: #DBDBDB;
     color: #111827;
     height: auto;
     text-decoration: none;
     display: inline-flex;
     align-items: center;
     justify-content: center;
     border: 1px solid #E5E7EB;
     cursor: pointer;
     transition: all 0.3s;
     min-height: 100%;
 }

 .sec-btn-outline:hover {
     background-color: #F3F4F6;
 }

 .sec-hero-features {
     display: flex;
     flex-wrap: wrap;
     max-width: 80%;

     gap: 15px;
 }

 .sec-hero-feature {
     display: flex;
     align-items: center;
     gap: 5px;
     font-size: 12px;
     color: #6A7282;
     /* text-transform: uppercase; */
     font-weight: 500;
 }

 .sec-hero-feature i {
     color: #D3B06C;
 }

 .sec-hero-image {
     flex: 1 1 500px;
     display: flex;
     justify-content: center;
     align-items: center;
     position: relative;
 }

 .sec-hero-image img {
     max-width: 100%;
     height: auto;
 }

 .sec-floating-card {
     position: absolute;
     background: #fff;
     border-radius: 40px;
     padding: 10px 26px;
     display: flex;
     align-items: center;
     gap: 10px;
     border: 1px solid #F3F4F6;
     box-shadow: 0 10px 15px rgb(0 0 0 / 9%);
     font-size: 22px;
     font-weight: 600;
     color: #364153;
 }

 .sec-hero-content .sec-btn-outline {
     background-color: transparent;
 }

 .sec-floating-iot {
     top: 20px;
     right: 10px;
 }

 .sec-floating-asset {
     bottom: 150px;
     left: 20px;
 }

 /* --- Layered Protection Section --- */
 .sec-layered {
     padding: 50px 0;
 }

 .sec-layered-header {
     display: flex;
     justify-content: space-between;
     align-items: flex-end;
     margin-bottom: 50px;
     flex-wrap: wrap;
     gap: 20px;
 }

 .sec-layered-title p {
     font-size: 14px;
     /* text-transform: uppercase; */
     color: #99A1AF;
     margin-bottom: 5px;
     font-weight: 600;
 }

 .sec-layered-title h2 {
     font-size: 40px;
     font-weight: 700;
     color: #101828;
     margin: 0;
     line-height: 1.2;
 }

 .sec-layered-tabs {
     display: flex;
     gap: 10px;
 }

 .sec-tab {
     padding: 8px 16px;
     border-radius: 50px;
     font-size: 14px;
     font-weight: 500;
     background-color: #EAEAEA;
     border: 1px solid #EAEAEA;
     color: #6A7282;
     cursor: pointer;
     border: none;
 }

 .sec-tab.active {
     background-color: #D1AA67;
     color: #fff;
 }

 .sec-layered-grid {
     display: grid;
     grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
     gap: 20px;
 }

 .sec-layer-card {
     background: #fff;
     border: 1px solid #F3F4F6;
     border-radius: 18px;
     padding: 25px;
     box-shadow: 0px 0px 10px #00000010;
     transition: all 0.3s ease;
 }

 .sec-layer-card:hover {
     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
     border-color: #E5E7EB;
 }

 .sec-layer-icon {
     width: 50px;
     height: 50px;
     border-radius: 16px;
     background-color: #FCF4E7;
     display: flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 20px;
 }

 .sec-layer-icon img {
     width: 20px;
     height: 20px;
 }

 .sec-layer-card h3 {
     font-size: 17px;
     font-weight: 600;
     color: #111827;
     margin-bottom: 10px;
 }

 .sec-layer-card p {
     font-size: 14px;
     color: #6B7280;
     line-height: 1.5;
     margin: 0;
 }

 /* --- Protection In Action Section --- */
 .sec-action {
     background-color: #161B28;
     border-radius: 20px;
     padding: 20px 10px 0px 70px;
     display: flex;
     align-items: center;
     margin: 40px 20px;
     color: #fff;
 }

 .sec-action-content {
     flex: 1 1 400px;
     padding-right: 40px;
     margin-top: 40px;
 }

 .sec-action-subtitle {
     font-size: 14px;
     color: #D1AA67;
     margin-bottom: 7px;
     font-weight: 500;
 }

 .sec-action-title {
     font-size: 40px;
     font-weight: 600;
     margin-bottom: 30px;
     line-height: 1.2;
 }

 .sec-action-list {
     list-style: none;
     padding: 0;
     margin: 45px 0px 60px;
     background-color: #1D293D;
     border-radius: 16px;
     border: 1px solid #314158;
     padding: 30px;
     max-width: 400px;
 }

 .sec-action-list li {
     display: flex;
     align-items: center;
     gap: 15px;
     margin-bottom: 12px;
     border-bottom: 1px solid #314158ab;
     font-size: 13px;
     padding-bottom: 12px;
     color: #CAD5E2;
 }

 .sec-action-list li:last-child {
     margin-bottom: 0;
 }

 .sec-action-list i {
     color: #D3B06C;
     font-size: 14px;
     background-color: #D1AA6730;
     width: 24px;
     height: 24px;
     align-items: center;
     display: flex;
     justify-content: center;
     border-radius: 100px;
 }

 .sec-action-image {
     width: 750px;
     display: flex;
     justify-content: center;
     max-width: 100%;
     margin-top: -80px;
 }

 .sec-action-image img {
     max-width: 100%;
     height: auto;
 }

 /* --- Compliance & Transparency Section --- */
 .sec-compliance {
     padding: 60px 0;
     display: flex;
     align-items: center;
     gap: 170px;
 }

 .sec-compliance-image {
     width: 540px;
     max-width: 100%;
     display: flex;
     justify-content: center;
 }

 .sec-compliance-image img {
     max-width: 100%;
     height: auto;
 }

 .sec-compliance-content {
     flex: 1 1 400px;
 }

 .sec-compliance-subtitle {
     font-size: 18px;
     /* text-transform: uppercase; */
     color: #99A1AF;
     letter-spacing: 1px;
     margin-bottom: 10px;
     font-weight: 600;
 }

 .sec-compliance-title {
     font-size: 40px;
     font-weight: 600;
     color: #101828;
     margin-bottom: 20px;
     line-height: 1.2;
 }

 .sec-compliance-desc {
     font-size: 20px;
     color: #6A7282;
     line-height: 1.6;
     margin-bottom: 20px;
 }

 .sec-compliance-list {
     list-style: none;
     padding: 0;
     margin: 0 0 30px 0;
 }

 .sec-compliance-list li {
     display: flex;
     align-items: center;
     gap: 10px;
     margin-bottom: 12px;
     font-size: 20px;
     color: #4A5565;
 }

 .sec-compliance-list i {
     color: #D1AA67;
     font-size: 20px;
 }

 .sec-link {
     color: #D1AA67;
     font-size: 20px;
     font-weight: 600;
     text-decoration: none;
     display: inline-flex;
     align-items: center;
     gap: 5px;
 }

 .sec-link:hover {
     text-decoration: underline;
 }

 /* --- Rely On Section --- */
 .sec-rely {
     background-color: #F9FAFB;
     padding: 80px 0;
     display: flex;
     flex-wrap: wrap;
     align-items: center;
     justify-content: space-between;
 }

 .sec-rely-content {
     max-width: 640px;
     padding-right: 10px;
 }

 .sec-rely-subtitle {
     font-size: 12px;
     text-transform: uppercase;
     color: #6B7280;
     letter-spacing: 1px;
     margin-bottom: 10px;
     font-weight: 600;
 }

 .sec-rely .security-container {
     justify-content: space-between;
     width: 100%;
     gap: 50px;
 }

 .sec-rely-title {
     font-size: 40px;
     font-weight: 700;
     color: #101828;
     margin-bottom: 20px;
     line-height: 1.2;
 }

 .sec-rely-title span {
     color: #D3B06C;
 }

 .sec-rely-desc {
     font-size: 20px;
     color: #6A7282;
     line-height: 1.6;
     margin-bottom: 30px;
 }

 .sec-rely-actions {
     display: flex;
     gap: 15px;
 }

 .sec-rely-image {
     width: 440px;
     max-width: 100%;
     display: flex;
     justify-content: center;
 }

 .sec-rely-image img {
     max-width: 100%;
     height: auto;
 }

 /* --- Trusted & Secured Section --- */
 .sec-trusted {
     padding: 80px 0;
     text-align: center;
 }

 .sec-trusted-title {
     font-size: 20px;
     font-weight: 700;
     color: #111827;
     margin-bottom: 40px;
 }

 .sec-trusted-grid {
     display: flex;
     flex-wrap: wrap;
     justify-content: center;
     gap: 20px;
 }

 .sec-trusted-card {
     background: #FBFBFB;
     border: 1px solid #F3F4F6;
     border-radius: 16px;
     padding: 20px;
     box-shadow: 0px 0px 20px #00000010;
     display: flex;
     flex-direction: column;
     align-items: center;
     min-width: 210px;
 }

 .sec-trusted-icon {
     width: 40px;
     height: 40px;
     background-color: #FFF9F0;
     border-radius: 8px;
     display: flex;
     align-items: center;
     justify-content: center;
     margin-bottom: 15px;
 }

 .sec-trusted-icon img {
     width: 46px;
 }

 .sec-trusted-card p {
     font-size: 14px;
     font-weight: 500;
     color: #4A5565;
     margin: 0;
     text-align: center;
 }


 @media (max-width:1500px) {

     .security-container {
         max-width: 90%;
     }

     .sec-hero-title {
         font-size: 48px;
     }

     .sec-floating-card {
         font-size: 18px;
     }

     .sec-action-content {
         flex: 1 1;
     }

     .sec-action-image {
         width: 580px;
     }

     .sec-action-title {
         font-size: 36px;
     }

     .sec-layered-title h2 {
         font-size: 36px;
     }

     .sec-compliance-title {
         font-size: 36px;
     }

     .sec-compliance-title {
         font-size: 36px;
     }


 }

 @media (max-width:1200px) {

     .sec-layered-grid {
         grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
     }

     .sec-action-image {
         width: 340px;
     }

     .sec-compliance-image {
         width: 350px;
     }

     .sec-action {
         padding: 20px 10px 0px 40px;
     }

     .sec-compliance {
         gap: 60px;
     }

     .sec-compliance-desc {
         font-size: 16px;
     }

     .sec-compliance-list li {
         font-size: 16px;
     }

     .sec-rely-title {
         font-size: 36px;
     }

     .sec-rely-desc {
         font-size: 16px;
     }

     .sec-hero-title {
         font-size: 40px;
     }

 }

 @media (max-width: 991px) {

     .sec-hero-actions a {
         padding: 9px 18px;
         text-align: center;
         font-size: 13px;
     }

     .sec-floating-card {
         font-size: 13px;
     }

     .sec-floating-asset {
         bottom: 50px;
     }

     .sec-hero-actions {
         margin-bottom: 24px;
     }

     .sec-hero {
         padding: 60px 0;
     }

     .security-container {
         max-width: 95%;
     }

     .sec-hero-title {
         font-size: 32px;
     }

     .sec-hero-title br {
         display: none;
     }

     .sec-hero-desc {
         font-size: 15px;
         margin-bottom: 24px;
         max-width: 100%;
     }

     .sec-action {
         margin: 20px 0;
         padding: 30px;
     }

     .sec-layered-header {
         flex-direction: column;
         align-items: flex-start;
     }


     .sec-compliance-desc {
         font-size: 15px;
     }

     .sec-compliance-list li {
         font-size: 15px;
     }

     .sec-rely-title {
         font-size: 32px;
     }

     .sec-rely-desc {
         font-size: 15px;
     }

     .sec-layered-header {
         margin-bottom: 32px;
     }

     .sec-layered-grid {
         grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
     }

     .sec-action-title {
         font-size: 26px;
     }

     .sec-action-title br {
         display: none;
     }

     .sec-action-list {
         margin: 20px 0px 20px;
         padding: 24px;
         max-width: 100%;
     }

     .sec-action-content {
         padding-right: 20px;
         margin-top: 0px;
     }

     .sec-compliance-title {
         font-size: 28px;
     }

     .sec-link {
         font-size: 15px;
     }


 }

 @media (max-width: 767px) {

     .sec-layered {
         padding: 0px 0 40px;
     }

     .sec-hero {
         text-align: center;
         padding: 42px 0 0px;
         flex-direction: column;
     }

     .sec-layered-title h2 {
         font-size: 24px;
     }

     .sec-tab {
         padding: 7px 14px;
         font-size: 12px;
         line-height: 14px;
     }

     .sec-action {
         padding: 24px;
         flex-direction: column;
     }

     .sec-action-image {
         margin-top: 0px;
     }

     .sec-action-content {
         padding-right: 0px;
     }

     .sec-compliance {
         gap: 40px;
         padding: 40px 0px;
         flex-direction: column;
     }

     .sec-rely {
         padding: 40px 0;
     }

     .sec-rely .security-container {
         flex-direction: column;
         gap: 40px;
     }

     .sec-trusted {
         padding: 40px 0;
     }

     .sec-trusted-card {
         padding: 18px;
         min-width: 140px;
     }

     .sec-trusted-title {
         margin-bottom: 20px;
     }

     .sec-hero-actions {
         justify-content: center;
     }

     .sec-hero-image {
         flex: 1 1;
         margin-top: 24px;
         max-width: 360px;
     }

     .sec-floating-asset {
         bottom: 40px;
     }

     .sec-compliance-title {
         font-size: 24px;
     }

     .sec-compliance-subtitle {
         font-size: 15px;
     }

     .sec-hero-content {
         flex: 1 1;
         padding-right: 0px;
     }

     .sec-hero-title {
         font-size: 26px;
     }

     .sec-hero-desc {
         margin-bottom: 18px;
     }

     .sec-hero-features {
         max-width: 100%;
         justify-content: center;
         gap: 10px;
     }

     .sec-floating-iot {
         top: 0px;
     }

     .sec-rely-title {
         font-size: 24px;
         margin-bottom: 10px;
     }

     .sec-floating-asset {
         bottom: 100px;
     }


 }`, "",{"version":3,"sources":["webpack://./src/ui/Pages/NewSecurity/security.css"],"names":[],"mappings":"CAAC;KACI,oEAAoE;KACpE,yBAAyB;KACzB,cAAc;KACd,kBAAkB;KAClB,oBAAoB;CACxB;;CAEA;KACI,sBAAsB;CAC1B;;CAEA;KACI,iBAAiB;KACjB,cAAc;KACd,eAAe;CACnB;;CAEA,yBAAyB;CACzB;KACI,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,eAAe;KACf,kBAAkB;CACtB;;CAEA;KACI,eAAe;KACf,mBAAmB;CACvB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,gBAAgB;KAChB,mBAAmB;KACnB,cAAc;CAClB;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,SAAS;KACT,mBAAmB;CACvB;;CAEA;KACI,yBAAyB;KACzB,WAAW;;KAEX,qBAAqB;KACrB,oBAAoB;KACpB,mBAAmB;KACnB,uBAAuB;KACvB,YAAY;KACZ,eAAe;KACf,oBAAoB;CACxB;;CAEA;KACI,yBAAyB;CAC7B;;CAEA;KACI,kBAAkB;KAClB,eAAe;KACf,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,kBAAkB;KAClB,eAAe;KACf,kBAAkB;KAClB,mBAAmB;KACnB,gBAAgB;CACpB;;;CAGA;KACI,yBAAyB;KACzB,cAAc;KACd,YAAY;KACZ,qBAAqB;KACrB,oBAAoB;KACpB,mBAAmB;KACnB,uBAAuB;KACvB,yBAAyB;KACzB,eAAe;KACf,oBAAoB;KACpB,gBAAgB;CACpB;;CAEA;KACI,yBAAyB;CAC7B;;CAEA;KACI,aAAa;KACb,eAAe;KACf,cAAc;;KAEd,SAAS;CACb;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,eAAe;KACf,cAAc;KACd,+BAA+B;KAC/B,gBAAgB;CACpB;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,kBAAkB;CACtB;;CAEA;KACI,eAAe;KACf,YAAY;CAChB;;CAEA;KACI,kBAAkB;KAClB,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;KAClB,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,yBAAyB;KACzB,uCAAuC;KACvC,eAAe;KACf,gBAAgB;KAChB,cAAc;CAClB;;CAEA;KACI,6BAA6B;CACjC;;CAEA;KACI,SAAS;KACT,WAAW;CACf;;CAEA;KACI,aAAa;KACb,UAAU;CACd;;CAEA,uCAAuC;CACvC;KACI,eAAe;CACnB;;CAEA;KACI,aAAa;KACb,8BAA8B;KAC9B,qBAAqB;KACrB,mBAAmB;KACnB,eAAe;KACf,SAAS;CACb;;CAEA;KACI,eAAe;KACf,+BAA+B;KAC/B,cAAc;KACd,kBAAkB;KAClB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,SAAS;KACT,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,SAAS;CACb;;CAEA;KACI,iBAAiB;KACjB,mBAAmB;KACnB,eAAe;KACf,gBAAgB;KAChB,yBAAyB;KACzB,yBAAyB;KACzB,cAAc;KACd,eAAe;KACf,YAAY;CAChB;;CAEA;KACI,yBAAyB;KACzB,WAAW;CACf;;CAEA;KACI,aAAa;KACb,2DAA2D;KAC3D,SAAS;CACb;;CAEA;KACI,gBAAgB;KAChB,yBAAyB;KACzB,mBAAmB;KACnB,aAAa;KACb,kCAAkC;KAClC,yBAAyB;CAC7B;;CAEA;KACI,2CAA2C;KAC3C,qBAAqB;CACzB;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,mBAAmB;KACnB,yBAAyB;KACzB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;KACI,WAAW;KACX,YAAY;CAChB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;CACvB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,SAAS;CACb;;CAEA,yCAAyC;CACzC;KACI,yBAAyB;KACzB,mBAAmB;KACnB,2BAA2B;KAC3B,aAAa;KACb,mBAAmB;KACnB,iBAAiB;KACjB,WAAW;CACf;;CAEA;KACI,eAAe;KACf,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,kBAAkB;KAClB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,gBAAgB;KAChB,UAAU;KACV,qBAAqB;KACrB,yBAAyB;KACzB,mBAAmB;KACnB,yBAAyB;KACzB,aAAa;KACb,gBAAgB;CACpB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,mBAAmB;KACnB,kCAAkC;KAClC,eAAe;KACf,oBAAoB;KACpB,cAAc;CAClB;;CAEA;KACI,gBAAgB;CACpB;;CAEA;KACI,cAAc;KACd,eAAe;KACf,2BAA2B;KAC3B,WAAW;KACX,YAAY;KACZ,mBAAmB;KACnB,aAAa;KACb,uBAAuB;KACvB,oBAAoB;CACxB;;CAEA;KACI,YAAY;KACZ,aAAa;KACb,uBAAuB;KACvB,eAAe;KACf,iBAAiB;CACrB;;CAEA;KACI,eAAe;KACf,YAAY;CAChB;;CAEA,8CAA8C;CAC9C;KACI,eAAe;KACf,aAAa;KACb,mBAAmB;KACnB,UAAU;CACd;;CAEA;KACI,YAAY;KACZ,eAAe;KACf,aAAa;KACb,uBAAuB;CAC3B;;CAEA;KACI,eAAe;KACf,YAAY;CAChB;;CAEA;KACI,eAAe;CACnB;;CAEA;KACI,eAAe;KACf,+BAA+B;KAC/B,cAAc;KACd,mBAAmB;KACnB,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,gBAAgB;KAChB,UAAU;KACV,kBAAkB;CACtB;;CAEA;KACI,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,mBAAmB;KACnB,eAAe;KACf,cAAc;CAClB;;CAEA;KACI,cAAc;KACd,eAAe;CACnB;;CAEA;KACI,cAAc;KACd,eAAe;KACf,gBAAgB;KAChB,qBAAqB;KACrB,oBAAoB;KACpB,mBAAmB;KACnB,QAAQ;CACZ;;CAEA;KACI,0BAA0B;CAC9B;;CAEA,4BAA4B;CAC5B;KACI,yBAAyB;KACzB,eAAe;KACf,aAAa;KACb,eAAe;KACf,mBAAmB;KACnB,8BAA8B;CAClC;;CAEA;KACI,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,eAAe;KACf,yBAAyB;KACzB,cAAc;KACd,mBAAmB;KACnB,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,8BAA8B;KAC9B,WAAW;KACX,SAAS;CACb;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,cAAc;CAClB;;CAEA;KACI,eAAe;KACf,cAAc;KACd,gBAAgB;KAChB,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,SAAS;CACb;;CAEA;KACI,YAAY;KACZ,eAAe;KACf,aAAa;KACb,uBAAuB;CAC3B;;CAEA;KACI,eAAe;KACf,YAAY;CAChB;;CAEA,sCAAsC;CACtC;KACI,eAAe;KACf,kBAAkB;CACtB;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,mBAAmB;CACvB;;CAEA;KACI,aAAa;KACb,eAAe;KACf,uBAAuB;KACvB,SAAS;CACb;;CAEA;KACI,mBAAmB;KACnB,yBAAyB;KACzB,mBAAmB;KACnB,aAAa;KACb,kCAAkC;KAClC,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,gBAAgB;CACpB;;CAEA;KACI,WAAW;KACX,YAAY;KACZ,yBAAyB;KACzB,kBAAkB;KAClB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;CACvB;;CAEA;KACI,WAAW;CACf;;CAEA;KACI,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,SAAS;KACT,kBAAkB;CACtB;;;CAGA;;KAEI;SACI,cAAc;KAClB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,SAAO;KACX;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;;CAGJ;;CAEA;;KAEI;SACI,2DAA2D;KAC/D;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,2BAA2B;KAC/B;;KAEA;SACI,SAAS;KACb;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;CAEJ;;CAEA;;KAEI;SACI,iBAAiB;SACjB,kBAAkB;SAClB,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,mBAAmB;KACvB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,cAAc;KAClB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,eAAe;SACf,mBAAmB;SACnB,eAAe;KACnB;;KAEA;SACI,cAAc;SACd,aAAa;KACjB;;KAEA;SACI,sBAAsB;SACtB,uBAAuB;KAC3B;;;KAGA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,mBAAmB;KACvB;;KAEA;SACI,2DAA2D;KAC/D;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,aAAa;KACjB;;KAEA;SACI,qBAAqB;SACrB,aAAa;SACb,eAAe;KACnB;;KAEA;SACI,mBAAmB;SACnB,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;;CAGJ;;CAEA;;KAEI;SACI,mBAAmB;KACvB;;KAEA;SACI,kBAAkB;SAClB,mBAAmB;SACnB,sBAAsB;KAC1B;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,iBAAiB;SACjB,eAAe;SACf,iBAAiB;KACrB;;KAEA;SACI,aAAa;SACb,sBAAsB;KAC1B;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,kBAAkB;KACtB;;KAEA;SACI,SAAS;SACT,iBAAiB;SACjB,sBAAsB;KAC1B;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,sBAAsB;SACtB,SAAS;KACb;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,aAAa;SACb,gBAAgB;KACpB;;KAEA;SACI,mBAAmB;KACvB;;KAEA;SACI,uBAAuB;KAC3B;;KAEA;SACI,SAAO;SACP,gBAAgB;SAChB,gBAAgB;KACpB;;KAEA;SACI,YAAY;KAChB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,SAAO;SACP,kBAAkB;KACtB;;KAEA;SACI,eAAe;KACnB;;KAEA;SACI,mBAAmB;KACvB;;KAEA;SACI,eAAe;SACf,uBAAuB;SACvB,SAAS;KACb;;KAEA;SACI,QAAQ;KACZ;;KAEA;SACI,eAAe;SACf,mBAAmB;KACvB;;KAEA;SACI,aAAa;KACjB;;;CAGJ","sourcesContent":[" .new-security-page {\n     font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n     background-color: #FFFFFF;\n     color: #0A0A0A;\n     overflow-x: hidden;\n     padding-bottom: 50px;\n }\n\n .new-security-page * {\n     box-sizing: border-box;\n }\n\n .security-container {\n     max-width: 1480px;\n     margin: 0 auto;\n     padding: 0 20px;\n }\n\n /* --- Hero Section --- */\n .sec-hero {\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     padding: 80px 0;\n     position: relative;\n }\n\n .sec-hero-content {\n     flex: 1 1 500px;\n     padding-right: 40px;\n }\n\n .sec-hero-title {\n     font-size: 60px;\n     font-weight: 600;\n     line-height: 1.1;\n     margin-bottom: 15px;\n     color: #101828;\n }\n\n .sec-hero-title span {\n     color: #D3B06C;\n }\n\n .sec-hero-desc {\n     font-size: 16px;\n     color: #6A7282;\n     line-height: 1.6;\n     margin-bottom: 35px;\n     max-width: 480px;\n }\n\n .sec-hero-actions {\n     display: flex;\n     gap: 15px;\n     margin-bottom: 40px;\n }\n\n .sec-btn-primary {\n     background-color: #D1AA67;\n     color: #fff;\n\n     text-decoration: none;\n     display: inline-flex;\n     align-items: center;\n     justify-content: center;\n     border: none;\n     cursor: pointer;\n     transition: all 0.3s;\n }\n\n .sec-btn-primary:hover {\n     background-color: #C09D5B;\n }\n\n .sec-hero-actions a {\n     padding: 10px 24px;\n     font-size: 14px;\n     border-radius: 30px;\n     font-weight: 500;\n }\n\n .sec-rely-actions a {\n     padding: 10px 24px;\n     font-size: 14px;\n     text-align: center;\n     border-radius: 30px;\n     font-weight: 500;\n }\n\n\n .sec-btn-outline {\n     background-color: #DBDBDB;\n     color: #111827;\n     height: auto;\n     text-decoration: none;\n     display: inline-flex;\n     align-items: center;\n     justify-content: center;\n     border: 1px solid #E5E7EB;\n     cursor: pointer;\n     transition: all 0.3s;\n     min-height: 100%;\n }\n\n .sec-btn-outline:hover {\n     background-color: #F3F4F6;\n }\n\n .sec-hero-features {\n     display: flex;\n     flex-wrap: wrap;\n     max-width: 80%;\n\n     gap: 15px;\n }\n\n .sec-hero-feature {\n     display: flex;\n     align-items: center;\n     gap: 5px;\n     font-size: 12px;\n     color: #6A7282;\n     /* text-transform: uppercase; */\n     font-weight: 500;\n }\n\n .sec-hero-feature i {\n     color: #D3B06C;\n }\n\n .sec-hero-image {\n     flex: 1 1 500px;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     position: relative;\n }\n\n .sec-hero-image img {\n     max-width: 100%;\n     height: auto;\n }\n\n .sec-floating-card {\n     position: absolute;\n     background: #fff;\n     border-radius: 40px;\n     padding: 10px 26px;\n     display: flex;\n     align-items: center;\n     gap: 10px;\n     border: 1px solid #F3F4F6;\n     box-shadow: 0 10px 15px rgb(0 0 0 / 9%);\n     font-size: 22px;\n     font-weight: 600;\n     color: #364153;\n }\n\n .sec-hero-content .sec-btn-outline {\n     background-color: transparent;\n }\n\n .sec-floating-iot {\n     top: 20px;\n     right: 10px;\n }\n\n .sec-floating-asset {\n     bottom: 150px;\n     left: 20px;\n }\n\n /* --- Layered Protection Section --- */\n .sec-layered {\n     padding: 50px 0;\n }\n\n .sec-layered-header {\n     display: flex;\n     justify-content: space-between;\n     align-items: flex-end;\n     margin-bottom: 50px;\n     flex-wrap: wrap;\n     gap: 20px;\n }\n\n .sec-layered-title p {\n     font-size: 14px;\n     /* text-transform: uppercase; */\n     color: #99A1AF;\n     margin-bottom: 5px;\n     font-weight: 600;\n }\n\n .sec-layered-title h2 {\n     font-size: 40px;\n     font-weight: 700;\n     color: #101828;\n     margin: 0;\n     line-height: 1.2;\n }\n\n .sec-layered-tabs {\n     display: flex;\n     gap: 10px;\n }\n\n .sec-tab {\n     padding: 8px 16px;\n     border-radius: 50px;\n     font-size: 14px;\n     font-weight: 500;\n     background-color: #EAEAEA;\n     border: 1px solid #EAEAEA;\n     color: #6A7282;\n     cursor: pointer;\n     border: none;\n }\n\n .sec-tab.active {\n     background-color: #D1AA67;\n     color: #fff;\n }\n\n .sec-layered-grid {\n     display: grid;\n     grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n     gap: 20px;\n }\n\n .sec-layer-card {\n     background: #fff;\n     border: 1px solid #F3F4F6;\n     border-radius: 18px;\n     padding: 25px;\n     box-shadow: 0px 0px 10px #00000010;\n     transition: all 0.3s ease;\n }\n\n .sec-layer-card:hover {\n     box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n     border-color: #E5E7EB;\n }\n\n .sec-layer-icon {\n     width: 50px;\n     height: 50px;\n     border-radius: 16px;\n     background-color: #FCF4E7;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     margin-bottom: 20px;\n }\n\n .sec-layer-icon img {\n     width: 20px;\n     height: 20px;\n }\n\n .sec-layer-card h3 {\n     font-size: 17px;\n     font-weight: 600;\n     color: #111827;\n     margin-bottom: 10px;\n }\n\n .sec-layer-card p {\n     font-size: 14px;\n     color: #6B7280;\n     line-height: 1.5;\n     margin: 0;\n }\n\n /* --- Protection In Action Section --- */\n .sec-action {\n     background-color: #161B28;\n     border-radius: 20px;\n     padding: 20px 10px 0px 70px;\n     display: flex;\n     align-items: center;\n     margin: 40px 20px;\n     color: #fff;\n }\n\n .sec-action-content {\n     flex: 1 1 400px;\n     padding-right: 40px;\n     margin-top: 40px;\n }\n\n .sec-action-subtitle {\n     font-size: 14px;\n     color: #D1AA67;\n     margin-bottom: 7px;\n     font-weight: 500;\n }\n\n .sec-action-title {\n     font-size: 40px;\n     font-weight: 600;\n     margin-bottom: 30px;\n     line-height: 1.2;\n }\n\n .sec-action-list {\n     list-style: none;\n     padding: 0;\n     margin: 45px 0px 60px;\n     background-color: #1D293D;\n     border-radius: 16px;\n     border: 1px solid #314158;\n     padding: 30px;\n     max-width: 400px;\n }\n\n .sec-action-list li {\n     display: flex;\n     align-items: center;\n     gap: 15px;\n     margin-bottom: 12px;\n     border-bottom: 1px solid #314158ab;\n     font-size: 13px;\n     padding-bottom: 12px;\n     color: #CAD5E2;\n }\n\n .sec-action-list li:last-child {\n     margin-bottom: 0;\n }\n\n .sec-action-list i {\n     color: #D3B06C;\n     font-size: 14px;\n     background-color: #D1AA6730;\n     width: 24px;\n     height: 24px;\n     align-items: center;\n     display: flex;\n     justify-content: center;\n     border-radius: 100px;\n }\n\n .sec-action-image {\n     width: 750px;\n     display: flex;\n     justify-content: center;\n     max-width: 100%;\n     margin-top: -80px;\n }\n\n .sec-action-image img {\n     max-width: 100%;\n     height: auto;\n }\n\n /* --- Compliance & Transparency Section --- */\n .sec-compliance {\n     padding: 60px 0;\n     display: flex;\n     align-items: center;\n     gap: 170px;\n }\n\n .sec-compliance-image {\n     width: 540px;\n     max-width: 100%;\n     display: flex;\n     justify-content: center;\n }\n\n .sec-compliance-image img {\n     max-width: 100%;\n     height: auto;\n }\n\n .sec-compliance-content {\n     flex: 1 1 400px;\n }\n\n .sec-compliance-subtitle {\n     font-size: 18px;\n     /* text-transform: uppercase; */\n     color: #99A1AF;\n     letter-spacing: 1px;\n     margin-bottom: 10px;\n     font-weight: 600;\n }\n\n .sec-compliance-title {\n     font-size: 40px;\n     font-weight: 600;\n     color: #101828;\n     margin-bottom: 20px;\n     line-height: 1.2;\n }\n\n .sec-compliance-desc {\n     font-size: 20px;\n     color: #6A7282;\n     line-height: 1.6;\n     margin-bottom: 20px;\n }\n\n .sec-compliance-list {\n     list-style: none;\n     padding: 0;\n     margin: 0 0 30px 0;\n }\n\n .sec-compliance-list li {\n     display: flex;\n     align-items: center;\n     gap: 10px;\n     margin-bottom: 12px;\n     font-size: 20px;\n     color: #4A5565;\n }\n\n .sec-compliance-list i {\n     color: #D1AA67;\n     font-size: 20px;\n }\n\n .sec-link {\n     color: #D1AA67;\n     font-size: 20px;\n     font-weight: 600;\n     text-decoration: none;\n     display: inline-flex;\n     align-items: center;\n     gap: 5px;\n }\n\n .sec-link:hover {\n     text-decoration: underline;\n }\n\n /* --- Rely On Section --- */\n .sec-rely {\n     background-color: #F9FAFB;\n     padding: 80px 0;\n     display: flex;\n     flex-wrap: wrap;\n     align-items: center;\n     justify-content: space-between;\n }\n\n .sec-rely-content {\n     max-width: 640px;\n     padding-right: 10px;\n }\n\n .sec-rely-subtitle {\n     font-size: 12px;\n     text-transform: uppercase;\n     color: #6B7280;\n     letter-spacing: 1px;\n     margin-bottom: 10px;\n     font-weight: 600;\n }\n\n .sec-rely .security-container {\n     justify-content: space-between;\n     width: 100%;\n     gap: 50px;\n }\n\n .sec-rely-title {\n     font-size: 40px;\n     font-weight: 700;\n     color: #101828;\n     margin-bottom: 20px;\n     line-height: 1.2;\n }\n\n .sec-rely-title span {\n     color: #D3B06C;\n }\n\n .sec-rely-desc {\n     font-size: 20px;\n     color: #6A7282;\n     line-height: 1.6;\n     margin-bottom: 30px;\n }\n\n .sec-rely-actions {\n     display: flex;\n     gap: 15px;\n }\n\n .sec-rely-image {\n     width: 440px;\n     max-width: 100%;\n     display: flex;\n     justify-content: center;\n }\n\n .sec-rely-image img {\n     max-width: 100%;\n     height: auto;\n }\n\n /* --- Trusted & Secured Section --- */\n .sec-trusted {\n     padding: 80px 0;\n     text-align: center;\n }\n\n .sec-trusted-title {\n     font-size: 20px;\n     font-weight: 700;\n     color: #111827;\n     margin-bottom: 40px;\n }\n\n .sec-trusted-grid {\n     display: flex;\n     flex-wrap: wrap;\n     justify-content: center;\n     gap: 20px;\n }\n\n .sec-trusted-card {\n     background: #FBFBFB;\n     border: 1px solid #F3F4F6;\n     border-radius: 16px;\n     padding: 20px;\n     box-shadow: 0px 0px 20px #00000010;\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     min-width: 210px;\n }\n\n .sec-trusted-icon {\n     width: 40px;\n     height: 40px;\n     background-color: #FFF9F0;\n     border-radius: 8px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     margin-bottom: 15px;\n }\n\n .sec-trusted-icon img {\n     width: 46px;\n }\n\n .sec-trusted-card p {\n     font-size: 14px;\n     font-weight: 500;\n     color: #4A5565;\n     margin: 0;\n     text-align: center;\n }\n\n\n @media (max-width:1500px) {\n\n     .security-container {\n         max-width: 90%;\n     }\n\n     .sec-hero-title {\n         font-size: 48px;\n     }\n\n     .sec-floating-card {\n         font-size: 18px;\n     }\n\n     .sec-action-content {\n         flex: 1;\n     }\n\n     .sec-action-image {\n         width: 580px;\n     }\n\n     .sec-action-title {\n         font-size: 36px;\n     }\n\n     .sec-layered-title h2 {\n         font-size: 36px;\n     }\n\n     .sec-compliance-title {\n         font-size: 36px;\n     }\n\n     .sec-compliance-title {\n         font-size: 36px;\n     }\n\n\n }\n\n @media (max-width:1200px) {\n\n     .sec-layered-grid {\n         grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n     }\n\n     .sec-action-image {\n         width: 340px;\n     }\n\n     .sec-compliance-image {\n         width: 350px;\n     }\n\n     .sec-action {\n         padding: 20px 10px 0px 40px;\n     }\n\n     .sec-compliance {\n         gap: 60px;\n     }\n\n     .sec-compliance-desc {\n         font-size: 16px;\n     }\n\n     .sec-compliance-list li {\n         font-size: 16px;\n     }\n\n     .sec-rely-title {\n         font-size: 36px;\n     }\n\n     .sec-rely-desc {\n         font-size: 16px;\n     }\n\n     .sec-hero-title {\n         font-size: 40px;\n     }\n\n }\n\n @media (max-width: 991px) {\n\n     .sec-hero-actions a {\n         padding: 9px 18px;\n         text-align: center;\n         font-size: 13px;\n     }\n\n     .sec-floating-card {\n         font-size: 13px;\n     }\n\n     .sec-floating-asset {\n         bottom: 50px;\n     }\n\n     .sec-hero-actions {\n         margin-bottom: 24px;\n     }\n\n     .sec-hero {\n         padding: 60px 0;\n     }\n\n     .security-container {\n         max-width: 95%;\n     }\n\n     .sec-hero-title {\n         font-size: 32px;\n     }\n\n     .sec-hero-title br {\n         display: none;\n     }\n\n     .sec-hero-desc {\n         font-size: 15px;\n         margin-bottom: 24px;\n         max-width: 100%;\n     }\n\n     .sec-action {\n         margin: 20px 0;\n         padding: 30px;\n     }\n\n     .sec-layered-header {\n         flex-direction: column;\n         align-items: flex-start;\n     }\n\n\n     .sec-compliance-desc {\n         font-size: 15px;\n     }\n\n     .sec-compliance-list li {\n         font-size: 15px;\n     }\n\n     .sec-rely-title {\n         font-size: 32px;\n     }\n\n     .sec-rely-desc {\n         font-size: 15px;\n     }\n\n     .sec-layered-header {\n         margin-bottom: 32px;\n     }\n\n     .sec-layered-grid {\n         grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n     }\n\n     .sec-action-title {\n         font-size: 26px;\n     }\n\n     .sec-action-title br {\n         display: none;\n     }\n\n     .sec-action-list {\n         margin: 20px 0px 20px;\n         padding: 24px;\n         max-width: 100%;\n     }\n\n     .sec-action-content {\n         padding-right: 20px;\n         margin-top: 0px;\n     }\n\n     .sec-compliance-title {\n         font-size: 28px;\n     }\n\n     .sec-link {\n         font-size: 15px;\n     }\n\n\n }\n\n @media (max-width: 767px) {\n\n     .sec-layered {\n         padding: 0px 0 40px;\n     }\n\n     .sec-hero {\n         text-align: center;\n         padding: 42px 0 0px;\n         flex-direction: column;\n     }\n\n     .sec-layered-title h2 {\n         font-size: 24px;\n     }\n\n     .sec-tab {\n         padding: 7px 14px;\n         font-size: 12px;\n         line-height: 14px;\n     }\n\n     .sec-action {\n         padding: 24px;\n         flex-direction: column;\n     }\n\n     .sec-action-image {\n         margin-top: 0px;\n     }\n\n     .sec-action-content {\n         padding-right: 0px;\n     }\n\n     .sec-compliance {\n         gap: 40px;\n         padding: 40px 0px;\n         flex-direction: column;\n     }\n\n     .sec-rely {\n         padding: 40px 0;\n     }\n\n     .sec-rely .security-container {\n         flex-direction: column;\n         gap: 40px;\n     }\n\n     .sec-trusted {\n         padding: 40px 0;\n     }\n\n     .sec-trusted-card {\n         padding: 18px;\n         min-width: 140px;\n     }\n\n     .sec-trusted-title {\n         margin-bottom: 20px;\n     }\n\n     .sec-hero-actions {\n         justify-content: center;\n     }\n\n     .sec-hero-image {\n         flex: 1;\n         margin-top: 24px;\n         max-width: 360px;\n     }\n\n     .sec-floating-asset {\n         bottom: 40px;\n     }\n\n     .sec-compliance-title {\n         font-size: 24px;\n     }\n\n     .sec-compliance-subtitle {\n         font-size: 15px;\n     }\n\n     .sec-hero-content {\n         flex: 1;\n         padding-right: 0px;\n     }\n\n     .sec-hero-title {\n         font-size: 26px;\n     }\n\n     .sec-hero-desc {\n         margin-bottom: 18px;\n     }\n\n     .sec-hero-features {\n         max-width: 100%;\n         justify-content: center;\n         gap: 10px;\n     }\n\n     .sec-floating-iot {\n         top: 0px;\n     }\n\n     .sec-rely-title {\n         font-size: 24px;\n         margin-bottom: 10px;\n     }\n\n     .sec-floating-asset {\n         bottom: 100px;\n     }\n\n\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
